module.exports = __webpack_public_path__ + "img/HTML_CONTENT.f9ebd6fa.svg";